import { Component, Input } from '@angular/core';
import { GridCell } from '../../../models/sections-model';

@Component({
  selector: 'kw-blog-nav-renderer',
  templateUrl: './blog-nav-renderer.component.html',
  styleUrls: ['./blog-nav-renderer.component.scss']
})
export class BlogNavRendererComponent {
  @Input() cell:GridCell;

}
